import { useQuery } from '@apollo/client';

import { GetUserHashedEmailDocument } from '../../graphql/queries/get-user-hashed-email.gql-types';

type UseUserHashedEmailValue = {
  isUserHashedEmailError: boolean;
  isUserHashedEmailLoading: boolean;
  userHashedEmail: string | null | undefined;
};

export const useUserHashedEmail = (): UseUserHashedEmailValue => {
  const { error, loading, data } = useQuery(GetUserHashedEmailDocument);
  const userHashedEmail = data?.viewer?.b2bProfileSettings?.hashedEmail;
  return {
    isUserHashedEmailError: !!error,
    isUserHashedEmailLoading: loading,
    userHashedEmail,
  };
};
